import { render, staticRenderFns } from "./ProductConfigBackLink.vue?vue&type=template&id=39012173&scoped=true&"
import script from "./ProductConfigBackLink.vue?vue&type=script&lang=js&"
export * from "./ProductConfigBackLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39012173",
  null
  
)

export default component.exports